import { Component, OnInit, OnDestroy } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications-toast',
  templateUrl: './notifications-toast.component.html',
  styleUrls: ['./notifications-toast.component.scss'],
})

export class NotificationsToastComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  subscriber: Subscription;

  constructor(
    private globalService: GlobalService,
    private router: Router
  ) {
    this.subscriber = this.globalService.request.subscribe((res) => {
      if (res) {
        switch (res['type']) {
          case 'NOTIFY':
            this.addNotification(res);
            break;
          default:
            break;
        }
      }
    });
  }

  private addNotification(notification) {
    this.notifications.push(notification);
    if (notification.timeout !== 0) {
      setTimeout(() => this.close(notification), notification.timeout);
    }
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.subscriber?.unsubscribe();
  }

  close(notification) {
    let element = document.getElementById(`${notification.id}`);
     if(element){
      element.classList.remove("animate__bounceInRight");
      element.classList.remove("animate__animated");
      element.classList.add("animate__animated");
      element.classList.add("animate__bounceOutRight");
     }
    setTimeout(() => {
     this.notifications = this.notifications.filter((notif:any) => notif.id !== notification.id); 
    }, 1000);
  }

  goUrl(notification){
    this.close(notification);
    if(notification['url'] && notification['url'].length > 0){
      const [path, queryParamsString] = notification['url'].split('?');
      const queryParams = Object.fromEntries(new URLSearchParams(queryParamsString));
      this.router.navigate([path], { queryParams });

      if(notification['url'].includes("messages") && screen.width < 1024){
        setTimeout(() => {
          this.globalService.sendRequest({ type: 'OPENCONTAINERCHAT' });
        }, 2000);
      }
      
    }
  }
}
